// This file was auto generated by resource-sync tools.

import en_translation from './en/translation.json';
import zh_translation from './zh/translation.json';
import zhHK_translation from './zh-HK/translation.json';

const resources = {
    'en': {
        translation: en_translation
    },
    'zh': {
        translation: zh_translation
    },
    'zh-HK': {
        translation: zhHK_translation
    }
};

export default resources;